import React from 'react';

import {Stack} from '@mui/material';

// import Delinquency from './Metrics/Delinquency';
import UnitsWithConcessions from './Metrics/UnitsWithConcessions';

const AccountPerformance = () => {
    return (
        <Stack direction="column" rowGap={2} sx={{width: '100%'}}>
            {/* <Delinquency /> */}
            <UnitsWithConcessions />
        </Stack>
    );
};

export default AccountPerformance;
